@layer base.theme {
  .media-skin[data-theme="minimal"] {
    --media-control-corner-shape: squircle;
    --media-control-radius: calc(var(--media-spacing) * 2);
    --media-control-size: calc(var(--media-spacing) * 9);
    --media-controls-radius: calc(var(--media-spacing) * 3);
    --media-popover: oklch(0% 0 0 / 0.5);
    --media-border: oklch(100% 0 0 / 0.1);
    --media-shadow-surface: 0 1px 2px oklch(0% 0 0 / 0.2);
    --media-shadow-thumb: 0 0 0 1px #00000026, 0 1px 3px 0 #00000026, 0 1px 2px -1px #00000026;
    --media-text-shadow-dialog: 0 1px 0 #00000080;
    --media-backdrop-filter-dialog: blur(16px) saturate(120%);
    --media-shadow-tooltip:
      0 0 0 1px var(--media-border), 0 4px 6px -1px oklch(0% 0 0 / 0.2), 0 2px 4px -2px oklch(0% 0 0 / 0.2);
    --media-duration-dialog: var(--media-duration);
    --media-duration-indicator: 0.4s;
    --media-hidden-offset: 100%;
    --media-hidden-indicator-offset: -100%;
    --media-menu-item-radius: calc(var(--media-spacing) * 1.5);
    --media-popover-boundary-offset: calc(var(--media-spacing) * 2);
    --media-popover-side-offset: calc(var(--media-spacing) * 5);
    --media-popup-radius: calc(var(--media-spacing) * 2.5);
    --media-popup-translate-distance: calc(var(--media-spacing) * 2);
    --media-dialog-width: 100%;
    --media-dialog-max-width: calc(var(--media-spacing) * 64);
    --media-slider-preview-label-offset: calc(var(--media-spacing) * 5);
    --media-video-border-radius: var(--media-border-radius, 12px);
  }

  .media-skin {
    --media-background: oklch(0% 0 0);
    --media-foreground: oklch(100% 0 0);
    --media-controls: oklch(0% 0 0 / 0.35);
    --media-controls-foreground: var(--media-foreground);
    --media-popover: oklch(100% 0 0 / 0.1);
    --media-popover-foreground: var(--media-foreground);
    --media-primary: var(--media-accent-color, var(--media-default-accent-color));
    --media-primary-foreground: var(
      --media-accent-text-color,
      contrast-color(var(--media-accent-color, var(--media-default-accent-color)))
    );
    --media-accent: var(--media-accent-color, color-mix(in oklab, var(--media-default-accent-color) 10%, transparent));
    --media-accent-foreground: var(
      --media-accent-text-color,
      contrast-color(var(--media-accent-color, var(--media-internal-accent-text-fallback, oklch(0% 0 0))))
    );
    --media-muted: oklch(100% 0 0 / 0.15);
    --media-muted-foreground: oklch(100% 0 0 / 0.65);
    --media-border: oklch(0% 0 0 / 0.1);
    --media-ring: oklch(100% 0 0);
    --media-backdrop: oklch(0% 0 0);
    --media-live-color: oklch(65% 0.22 27);
    --media-shadow-surface: 0 1px 3px 0 oklch(0% 0 0 / 0.15), 0 1px 2px -1px oklch(0% 0 0 / 0.15);
    --media-shadow-surface-inset: inset 0 1px 0 0 #ffffff1a, inset 0 0 0 1px #ffffff0d;
    --media-shadow-thumb: 0 0 0 1px #0000001a, 0 1px 3px 0 #00000059, 0 1px 2px -1px #00000059;
    --media-shadow-tooltip: 0 0 0 1px var(--media-border), var(--media-shadow-surface);
    --media-shadow-separator: 0 1px 0 0 oklch(100% 0 0 / 0.075);
    --media-shadow-current-color: oklch(from currentColor 0 0 0 / clamp(0, calc((l - 0.5) * 0.5), 0.15));
    --media-shadow-subtle-current-color: oklch(from var(--media-shadow-current-color) l c h / calc(alpha * 0.4));
    --media-text-shadow-dialog: 0 1px 0 #00000040;
    --media-backdrop-filter-surface: blur(16px) saturate(150%);
    --media-backdrop-filter-indicator: blur(8px);
    --media-backdrop-filter-dialog: blur(16px) saturate(150%);
    --media-control-corner-shape: round;
    --media-control-radius: 99px;
    --media-control-size: calc(var(--media-spacing) * 9);
    --media-controls-radius: var(--media-control-radius);
    --media-default-accent-color: oklch(100% 0 0);
    --media-duration-instant: 50ms;
    --media-duration-fast: 0.1s;
    --media-duration: 0.15s;
    --media-duration-slow: 0.2s;
    --media-duration-slower: 0.25s;
    --media-duration-controls: 0.1s;
    --media-duration-dialog: 0.35s;
    --media-duration-indicator: var(--media-duration-slower);
    --media-duration-menu: 0.25s;
    --media-duration-slider: var(--media-duration-fast);
    --media-delay-dialog: 0.1s;
    --media-hidden-scale: 0.95;
    --media-hidden-blur: 8px;
    --media-hidden-offset: calc(var(--media-spacing) * 1);
    --media-hidden-icon-scale: 0;
    --media-hidden-indicator-scale: 0.9;
    --media-hidden-indicator-offset: -25%;
    --media-hidden-playback-scale: 0.85;
    --media-hidden-popup-scale: 0.95;
    --media-hidden-popup-blur: 4px;
    --media-hidden-preview-scale: 0.8;
    --media-hidden-preview-offset: calc(var(--media-spacing) * 2);
    --media-hidden-seek-offset: 60%;
    --media-menu-item-radius: calc(var(--media-spacing) * 2);
    --media-popover-boundary-offset: calc(var(--media-spacing) * 3);
    --media-popover-side-offset: calc(var(--media-spacing) * 3);
    --media-popup-radius: calc(var(--media-spacing) * 3);
    --media-popup-translate-distance: calc(var(--media-spacing) * 2);
    --media-tooltip-boundary-offset: var(--media-popover-boundary-offset);
    --media-tooltip-side-offset: var(--media-popover-side-offset);
    --media-dialog-radius: calc(var(--media-spacing) * 7);
    --media-dialog-width: calc(100% - var(--media-spacing) * 6);
    --media-dialog-max-width: calc(var(--media-spacing) * 72);
    --media-slider-preview-label-offset: calc(var(--media-spacing) * 10.5);
    --media-video-border-radius: var(--media-border-radius, 28px);
    --media-scale: 1;
    --media-scrollbar-thumb-color: oklch(from currentColor l c h / 0.3);
    --media-spacing: calc(var(--media-scale-unit, 16px) * var(--media-scale) / 4);
    scrollbar-color: var(--media-scrollbar-thumb-color) transparent;
    scrollbar-width: thin;
  }

  .media-skin::-webkit-scrollbar-thumb {
    background: var(--media-scrollbar-thumb-color);
    border-radius: 9999px;
  }

  .media-skin:fullscreen {
    --media-object-fit: contain;
    --media-video-border-radius: 0;
  }

  @media (width >= 1280px) {
    .media-skin:fullscreen {
      --media-scale: 1.25;
    }
  }

  @media (width >= 1536px) {
    .media-skin:fullscreen {
      --media-scale: 1.5;
    }
  }

  @media (width >= 1920px) {
    .media-skin:fullscreen {
      --media-scale: 1.75;
    }
  }
}

@layer base.preset {
  .media-skin:is([data-preset="video"], [data-preset="live-video"]) {
    --media-frame-border: var(--media-border-color, light-dark(#0000001a, #ffffff26));
    --media-controls-gradient: linear-gradient(
      to top in oklab,
      oklch(from var(--media-backdrop) l c h / 0.4),
      oklch(from var(--media-backdrop) l c h / 0.2),
      oklch(from var(--media-backdrop) l c h / 0.5)
    );
    --media-caption-controls-y: calc(var(--media-spacing) * -14);
    --media-slider-preview-offset: calc(var(--media-spacing) * 9);
    --media-thumbnail-gradient: linear-gradient(
      to top,
      oklch(from var(--media-backdrop) l c h / 0.5),
      oklch(from var(--media-backdrop) l c h / 0.1),
      transparent
    );
  }

  .media-skin:is([data-preset="video"], [data-preset="live-video"])[data-theme="minimal"] {
    --media-frame-border: var(--media-border-color, light-dark(#00000026, #ffffff26));
    --media-controls-gradient: linear-gradient(
      to top in oklab,
      oklch(from var(--media-backdrop) l c h / 0.5),
      oklch(from var(--media-backdrop) l c h / 0.2)
    );
    --media-indicator-gradient: linear-gradient(
      to bottom,
      oklch(from var(--media-backdrop) l c h / 0.35),
      oklch(from var(--media-backdrop) l c h / 0.2) calc(var(--media-spacing) * 12),
      transparent
    );
    --media-caption-controls-y: calc(var(--media-spacing) * -18);
    --media-slider-preview-offset: calc(var(--media-spacing) * 11);
  }
}

@layer base.preferences {
  @media (pointer: fine) and (prefers-reduced-motion: no-preference) {
    .media-skin:not([data-controls-visible]) {
      --media-duration-controls: 0.3s;
    }
  }

  @media (pointer: coarse) and (prefers-reduced-motion: no-preference) {
    .media-skin:not([data-controls-visible]) {
      --media-duration-controls: 0.15s;
    }
  }

  @media (prefers-reduced-motion: reduce) {
    .media-skin {
      --media-duration-fast: var(--media-duration-instant);
      --media-duration: var(--media-duration-instant);
      --media-duration-slow: var(--media-duration-instant);
      --media-duration-slower: var(--media-duration-instant);
      --media-duration-controls: var(--media-duration-instant);
      --media-duration-dialog: var(--media-duration-instant);
      --media-duration-indicator: var(--media-duration-instant);
      --media-duration-menu: 0s;
      --media-duration-slider: 0s;
      --media-delay-dialog: 0s;
      --media-hidden-scale: 1;
      --media-hidden-blur: 0px;
      --media-hidden-offset: 0px;
      --media-hidden-icon-scale: 1;
      --media-hidden-indicator-scale: 1;
      --media-hidden-indicator-offset: 0px;
      --media-hidden-playback-scale: 1;
      --media-hidden-popup-scale: 1;
      --media-hidden-popup-blur: 0px;
      --media-hidden-preview-scale: 1;
      --media-hidden-preview-offset: 0px;
      --media-hidden-seek-offset: 0px;
      --media-popup-translate-distance: 0px;
      --media-spinner-animation: none;
      --media-icon-airplay-fill-animation: none;
      --media-icon-airplay-triangle-animation: none;
    }
  }

  @media (prefers-reduced-transparency: reduce), (prefers-contrast: more) {
    .media-skin {
      --media-popover: var(--media-background);
      --media-scrollbar-thumb-color: oklch(from currentColor l c h / 0.8);
      --media-backdrop-filter-surface: none;
      --media-backdrop-filter-indicator: none;
      --media-backdrop-filter-dialog: none;
      --media-shadow-surface-inset: inset 0 1px 0 0 #ffffff40, inset 0 0 0 1px #ffffff20;
      scrollbar-width: auto;
    }
  }

  @media (forced-colors: active) {
    .media-skin {
      --media-border: CanvasText;
      --media-frame-border: CanvasText;
      --media-popover: Canvas;
      --media-popover-foreground: CanvasText;
      --media-ring: CanvasText;
      --media-shadow-surface-inset: inset 0 1px 0 0 CanvasText, inset 0 0 0 1px CanvasText;
    }
  }
}

@layer base {
  @scope (.media-skin) {
    :scope {
      text-align: start;
      text-transform: none;
      letter-spacing: normal;
      font-style: normal;
      font-weight: 400;
    }

    :scope,
    *,
    :before,
    :after {
      box-sizing: border-box;
      border: 0 solid;
      margin: 0;
      padding: 0;
    }

    button {
      font: inherit;
      color: inherit;
      text-transform: none;
      letter-spacing: inherit;
      appearance: none;
      background: none;
    }

    img,
    svg,
    media-icon {
      max-width: 100%;
      display: block;
    }

    svg[fill="currentColor"] {
      fill: currentColor;
    }

    svg[fill="none"] {
      fill: none;
    }

    svg[stroke="currentColor"] {
      stroke: currentColor;
    }

    video {
      border-radius: inherit;
      object-fit: var(--media-object-fit, contain);
      object-position: var(--media-object-position, center);
      width: 100%;
      max-width: 100%;
      height: 100%;
      display: block;
    }

    media-icon > svg {
      width: 100%;
      height: 100%;
    }

    media-tooltip-group,
    media-dialog,
    media-alert-dialog,
    media-error-dialog,
    media-controls {
      display: contents;
    }

    [hidden][hidden] {
      display: none !important;
    }
  }

  @media (prefers-reduced-motion: no-preference) {
    .media-skin {
      interpolate-size: allow-keywords;
    }
  }

  @supports not selector(:popover-open) {
    :where(.media-skin) [popover]:not([data-open], [data-ending-style]) {
      display: none !important;
    }

    .media-skin:is([data-preset="audio"], [data-preset="live-audio"]) {
      overflow: visible !important;
    }
  }
}

@layer components {
  @scope (.media-skin) {
    :scope {
      --media-caption-track-duration: var(--media-duration-controls);
      --media-caption-track-delay: 25ms;
      --media-caption-track-y: calc(var(--media-spacing) * -2);
    }

    video::-webkit-media-text-track-container {
      z-index: 20;
      scale: 0.98;
      translate: 0 var(--media-caption-track-y);
      transition: translate var(--media-caption-track-duration) ease-out;
      transition-delay: var(--media-caption-track-delay);
      font-family: inherit;
    }

    :scope[data-controls-visible] {
      --media-caption-track-y: var(--media-caption-controls-y);
    }

    @container media-root (width >= 42rem) {
      :scope[data-theme="minimal"][data-controls-visible] video {
        --media-caption-track-y: calc(var(--media-spacing) * -12);
      }
    }
  }

  @scope (.media-skin[data-theme="minimal"]) {
    .media-button {
      width: var(--media-control-size);
      height: var(--media-control-size);
      cursor: pointer;
      touch-action: manipulation;
      border-radius: var(--media-control-radius);
      text-align: center;
      min-height: 0;
      color: inherit;
      outline-offset: -2px;
      transition-property: background-color, color, outline-offset, scale;
      transition-duration: var(--media-duration);
      will-change: scale;
      -webkit-user-select: none;
      user-select: none;
      corner-shape: var(--media-control-corner-shape);
      background-color: #0000;
      border-style: solid;
      border-width: 0;
      outline: 2px solid #0000;
      flex-shrink: 0;
      place-items: center;
      padding: 0;
      transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
      display: grid;
    }

    @media (hover: hover) {
      .media-button:not([aria-disabled="true"]):hover {
        background-color: var(--media-accent);
        color: var(--media-accent-foreground);
      }
    }

    .media-button:focus-visible {
      outline-offset: 2px;
      outline-color: var(--media-ring);
    }

    .media-button:not([aria-disabled="true"]):active {
      scale: 0.97;
    }

    .media-button[aria-disabled="true"] {
      cursor: not-allowed;
      opacity: 0.5;
    }

    @supports (corner-shape: squircle) {
      .media-button {
        border-radius: 1rem;
      }
    }

    @media (prefers-reduced-motion: reduce) {
      .media-button {
        will-change: auto;
        transition-property: background-color, color;
        scale: 1;
      }
    }

    .media-button:where(:focus-visible, [aria-expanded="true"], [data-highlighted]):where(
        :not([aria-disabled="true"])
      ) {
      background-color: var(--media-accent);
      color: var(--media-accent-foreground);
    }
  }

  @scope (.media-skin[data-theme="minimal"]) {
    .media-dialog-actions {
      gap: calc(var(--media-spacing) * 2);
      flex-shrink: 0;
      display: flex;
    }

    .media-dialog-backdrop {
      z-index: 40;
      border-radius: inherit;
      background-color: var(--media-backdrop);
      opacity: 1;
      backdrop-filter: var(--media-backdrop-filter-dialog);
      transition-property: opacity;
      transition-duration: 0.15s;
      transition-delay: var(--media-delay-dialog);
      transition-duration: var(--media-duration-dialog);
      transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
      position: absolute;
      inset: 0;
    }

    @supports (color: color-mix(in lab, red, red)) {
      .media-dialog-backdrop {
        background-color: color-mix(in oklab, var(--media-backdrop) 20%, transparent);
      }
    }

    .media-dialog-backdrop:not([data-open]) {
      display: none;
    }

    .media-dialog-backdrop[data-ending-style] {
      transition-delay: 0s;
      transition-duration: var(--media-duration-instant);
    }

    .media-dialog-backdrop:is([data-starting-style], [data-ending-style]) {
      opacity: 0;
    }

    .media-dialog-close {
      height: var(--media-control-size);
      width: 100%;
      padding-inline: calc(var(--media-spacing) * 4);
      padding-block: calc(var(--media-spacing) * 2);
      flex: 1;
      font-weight: 500;
      background-color: var(--media-primary) !important;
      color: var(--media-primary-foreground) !important;
    }

    .media-dialog-content {
      gap: calc(var(--media-spacing) * 2);
      min-height: 0;
      padding-block: calc(var(--media-spacing) * 1.5);
      flex-direction: column;
      display: flex;
      overflow-y: auto;
    }

    .media-dialog-description {
      overflow-wrap: anywhere;
      opacity: 0.7;
      margin: 0;
    }

    .media-dialog-popup {
      z-index: 50;
      max-height: calc(100% - 0.5rem);
      width: var(--media-dialog-width);
      max-width: var(--media-dialog-max-width);
      gap: calc(var(--media-spacing) * 3);
      border-radius: var(--media-dialog-radius);
      padding: calc(var(--media-spacing) * 4);
      color: var(--media-popover-foreground);
      transition-property: opacity, scale;
      transition-duration: 0.15s;
      transition-delay: var(--media-delay-dialog);
      transition-duration: var(--media-duration-dialog);
      text-shadow: var(--media-text-shadow-dialog);
      outline-style: none;
      flex-direction: column;
      transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
      display: flex;
      position: absolute;
      top: 50%;
      left: 50%;
      translate: -50% -50%;
    }

    @media (forced-colors: active) {
      .media-dialog-popup {
        outline-offset: 2px;
        outline: 2px solid #0000;
      }
    }

    .media-dialog-popup:not([data-open]) {
      display: none;
    }

    .media-dialog-popup[data-ending-style] {
      transition-delay: 0s;
      transition-duration: var(--media-duration-instant);
    }

    .media-dialog-popup:is([data-starting-style], [data-ending-style]) {
      scale: var(--media-hidden-popup-scale) var(--media-hidden-popup-scale);
      opacity: 0;
    }

    .media-dialog-title {
      font-size: calc(var(--media-spacing) * 3.75);
      margin: 0;
      font-weight: 600;
      line-height: 1.25;
    }
  }

  @scope (.media-skin[data-theme="minimal"]) {
    .media-buffering-indicator {
      pointer-events: none;
      color: var(--media-controls-foreground);
      place-content: center;
      display: none;
      position: absolute;
      inset: 0;
    }

    .media-buffering-indicator:not([data-visible]) {
      --media-spinner-animation: none;
    }

    .media-buffering-indicator:before {
      background-color: var(--media-backdrop);
      content: "";
      backdrop-filter: var(--media-backdrop-filter-indicator);
      position: absolute;
      inset: 0;
    }

    @supports (color: color-mix(in lab, red, red)) {
      .media-buffering-indicator:before {
        background-color: color-mix(in oklab, var(--media-backdrop) 35%, transparent);
      }
    }

    .media-buffering-indicator[data-visible] {
      display: grid;
    }

    .media-buffering-indicator-spinner-icon {
      z-index: 30;
      width: var(--media-icon-size, calc(var(--media-spacing) * 4.5));
      height: var(--media-icon-size, calc(var(--media-spacing) * 4.5));
      filter: drop-shadow(0 1px 0 var(--media-shadow-current-color));
      position: relative;
    }
  }

  @scope (.media-skin[data-theme="minimal"]) {
    .media-poster {
      pointer-events: none;
      border-radius: inherit;
      width: 100%;
      height: 100%;
      transition-property: opacity;
      transition-duration: 0.15s;
      transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
      transition-duration: var(--media-duration-slower);
      position: absolute;
      inset: 0;
    }

    .media-poster:not([data-visible]) {
      opacity: 0;
    }

    .media-poster-image {
      border-radius: inherit;
      object-fit: var(--media-object-fit, contain);
      object-position: var(--media-object-position, center);
      width: 100%;
      height: 100%;
      position: absolute;
      inset: 0;
    }

    .media-poster-image:not([src]):not([srcset]) {
      visibility: hidden;
    }
  }

  .media-poster > slot::slotted(img) {
    border-radius: inherit;
    object-fit: var(--media-object-fit, contain);
    object-position: var(--media-object-position, center);
    width: 100%;
    height: 100%;
    position: absolute;
    inset: 0;
    height: 100% !important;
  }

  .media-poster > slot::slotted(img:not([src]):not([srcset])) {
    visibility: hidden;
  }

  :where(.media-skin[data-theme="minimal"]) .media-poster {
    pointer-events: none;
    border-radius: inherit;
    width: 100%;
    height: 100%;
    transition-property: opacity;
    transition-duration: 0.15s;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: var(--media-duration-slower);
    position: absolute;
    inset: 0;
  }

  :where(.media-skin[data-theme="minimal"]) .media-poster:not([data-visible]) {
    opacity: 0;
  }

  :where(.media-skin[data-theme="minimal"]) .media-poster-image {
    border-radius: inherit;
    object-fit: var(--media-object-fit, contain);
    object-position: var(--media-object-position, center);
    width: 100%;
    height: 100%;
    position: absolute;
    inset: 0;
  }

  :where(.media-skin[data-theme="minimal"]) .media-poster-image:not([src]):not([srcset]) {
    visibility: hidden;
  }

  @scope (.media-skin[data-theme="minimal"]) {
    .media-title {
      pointer-events: none;
      isolation: isolate;
      z-index: 20;
      transform-origin: top;
      padding-inline: calc(var(--media-spacing) * 4);
      padding-top: calc(var(--media-spacing) * 2.5);
      font-size: calc(var(--media-spacing) * 3.25);
      letter-spacing: -0.0125em;
      overflow-wrap: anywhere;
      color: var(--media-controls-foreground);
      transition-property: filter, opacity, translate;
      transition-duration: 0.15s;
      transition-duration: calc(var(--media-duration-controls) / 2);
      text-shadow: 0 1px 0 var(--media-shadow-current-color);
      inset-inline: 0;
      font-weight: 400;
      transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
      position: absolute;
      top: 0;
    }

    .media-title:not([data-visible]) {
      translate: 0 calc(min(var(--media-hidden-offset), var(--media-control-size)) * -1);
      opacity: 0;
      transition-duration: var(--media-duration-controls);
    }

    @media (pointer: fine) {
      .media-title:not([data-visible]) {
        filter: blur(var(--media-hidden-blur));
      }
    }

    @container media-root (width >= 28rem) {
      .media-title {
        padding-inline: calc(var(--media-spacing) * 6);
        padding-top: calc(var(--media-spacing) * 4);
        font-size: calc(var(--media-spacing) * 4.25);
      }
    }
  }

  @scope (.media-skin[data-theme="minimal"]) {
    .media-container,
    :scope.media-container {
      isolation: isolate;
      border-radius: var(--media-video-border-radius);
      background-color: var(--media-background);
      width: 100%;
      min-width: 0;
      height: 100%;
      min-height: 0;
      font-family: var(--media-font-family, "Inter Variable", Inter, ui-sans-serif, system-ui, sans-serif);
      font-size: calc(var(--media-spacing) * 3.25);
      -webkit-font-smoothing: auto;
      -moz-osx-font-smoothing: auto;
      outline-offset: -4px;
      transition-property: outline-offset, outline-color;
      transition-duration: 0.15s;
      transition-duration: var(--media-duration-fast);
      --spacing: var(--media-spacing);
      outline: 2px solid #0000;
      line-height: 1.5;
      transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
      display: block;
      position: relative;
      overflow: clip;
      container: media-root / inline-size;
    }

    .media-container:after,
    :scope.media-container:after {
      pointer-events: none;
      z-index: 10;
      border-radius: inherit;
      content: "";
      border-style: solid;
      border-width: 1px;
      border-color: var(--media-frame-border);
      position: absolute;
      inset: 0;
    }

    .media-container:focus-visible,
    :scope.media-container:focus-visible {
      outline-offset: 2px;
      outline-color: var(--media-ring);
    }

    .media-container:fullscreen:after,
    :scope.media-container:fullscreen:after {
      content: "";
      display: none;
    }
  }

  .media-container > slot::slotted(video),
  :scope.media-container > slot::slotted(video) {
    border-radius: inherit;
    object-fit: var(--media-object-fit, contain);
    object-position: var(--media-object-position, center);
    width: 100%;
    max-width: 100%;
    height: 100%;
    margin: 0;
    display: block;
  }

  @scope (.media-skin[data-theme="minimal"]) {
    .media-status-announcer {
      clip-path: inset(50%);
      white-space: nowrap;
      border-width: 0;
      width: 1px;
      height: 1px;
      margin: -1px;
      padding: 0;
      position: absolute;
      overflow: hidden;
    }
  }

  @scope (.media-skin[data-theme="minimal"]) {
    .media-indicator {
      pointer-events: none;
      transform-origin: top;
      background-image: var(--media-indicator-gradient);
      padding-top: calc(var(--media-spacing) * 3);
      padding-bottom: calc(var(--media-spacing) * 32);
      color: inherit;
      transition-duration: var(--media-duration-fast);
      text-shadow: 0 1px 0 var(--media-shadow-current-color);
      inset-inline: 0;
      justify-content: center;
      transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
      display: flex;
      position: absolute;
      top: 0;
    }

    .media-indicator[data-ending-style] {
      translate: 0 var(--media-hidden-indicator-offset);
    }

    @media (pointer: coarse) {
      .media-indicator {
        will-change: translate, opacity;
        transition-property: translate, opacity;
      }
    }

    @media (pointer: fine) {
      .media-indicator {
        will-change: translate, filter, opacity;
        transition-property: translate, filter, opacity;
      }
    }

    .media-indicator:is([data-starting-style], [data-ending-style]) {
      opacity: 0;
      transition-duration: var(--media-duration-indicator);
      transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
    }

    @media (pointer: fine) {
      .media-indicator:is([data-starting-style], [data-ending-style]) {
        filter: blur(var(--media-hidden-blur));
      }
    }

    .media-indicator-content {
      justify-content: space-between;
      align-items: center;
      gap: calc(var(--media-spacing) * 2);
      padding-inline: calc(var(--media-spacing) * 2.5);
      padding-block: var(--media-spacing);
    }

    @media (prefers-reduced-transparency: reduce), (prefers-contrast: more) {
      .media-indicator-content {
        border-radius: var(--media-control-radius);
        background-color: var(--media-background);
      }
    }

    .media-playback-status-indicator {
      padding: calc(var(--media-spacing) * 4);
      text-align: center;
      transition-property: opacity, scale;
      transition-duration: 0.15s;
      transition-duration: var(--media-duration-slow);
      grid-row-start: 1;
      grid-column-start: 2;
      place-content: center;
      transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
      display: grid;
    }

    .media-playback-status-indicator[data-ending-style] {
      transition-duration: var(--media-duration-fast);
      transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
    }

    .media-playback-status-indicator:is([data-starting-style], [data-ending-style]) {
      scale: var(--media-hidden-playback-scale) var(--media-hidden-playback-scale);
      opacity: 0;
    }

    .media-playback-status-indicator-pause-icon {
      width: calc(var(--media-icon-size, calc(var(--media-spacing) * 4.5)) * 2);
      height: calc(var(--media-icon-size, calc(var(--media-spacing) * 4.5)) * 2);
      scale: var(--media-hidden-icon-scale) var(--media-hidden-icon-scale);
      opacity: 0;
      transition-property: opacity, scale;
      transition-duration: 0.15s;
      transition-duration: var(--media-duration);
      grid-row-start: 1;
      grid-column-start: 1;
      transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
    }

    @scope (.media-playback-status-indicator) {
      &[data-status="pause"] .media-playback-status-indicator-pause-icon {
        opacity: 1;
        scale: 1;
      }
    }

    .media-playback-status-indicator-play-icon {
      width: calc(var(--media-icon-size, calc(var(--media-spacing) * 4.5)) * 2);
      height: calc(var(--media-icon-size, calc(var(--media-spacing) * 4.5)) * 2);
      scale: var(--media-hidden-icon-scale) var(--media-hidden-icon-scale);
      opacity: 0;
      transition-property: opacity, scale;
      transition-duration: 0.15s;
      transition-duration: var(--media-duration);
      grid-row-start: 1;
      grid-column-start: 1;
      transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
    }

    @scope (.media-playback-status-indicator) {
      &[data-status="play"] .media-playback-status-indicator-play-icon {
        opacity: 1;
        scale: 1;
      }
    }

    .media-status-indicator-captions-off-icon {
      filter: drop-shadow(0 1px 0 var(--media-shadow-current-color));
      flex-shrink: 0;
      display: none;
    }

    @scope (.media-status-indicator) {
      &[data-status="captions-off"] .media-status-indicator-captions-off-icon {
        display: block;
      }
    }

    .media-status-indicator-captions-on-icon {
      filter: drop-shadow(0 1px 0 var(--media-shadow-current-color));
      flex-shrink: 0;
      display: none;
    }

    @scope (.media-status-indicator) {
      &[data-status="captions-on"] .media-status-indicator-captions-on-icon {
        display: block;
      }
    }

    .media-status-indicator-content {
      display: flex;
    }

    .media-status-indicator-fullscreen-enter-icon {
      filter: drop-shadow(0 1px 0 var(--media-shadow-current-color));
      flex-shrink: 0;
      display: none;
    }

    @scope (.media-status-indicator) {
      &[data-status="fullscreen"] .media-status-indicator-fullscreen-enter-icon {
        display: block;
      }
    }

    .media-status-indicator-fullscreen-exit-icon {
      filter: drop-shadow(0 1px 0 var(--media-shadow-current-color));
      flex-shrink: 0;
      display: none;
    }

    @scope (.media-status-indicator) {
      &[data-status="exit-fullscreen"] .media-status-indicator-fullscreen-exit-icon {
        display: block;
      }
    }

    .media-status-indicator-pip-enter-icon {
      filter: drop-shadow(0 1px 0 var(--media-shadow-current-color));
      flex-shrink: 0;
      display: none;
    }

    @scope (.media-status-indicator) {
      &[data-status="pip"] .media-status-indicator-pip-enter-icon {
        display: block;
      }
    }

    .media-status-indicator-pip-exit-icon {
      filter: drop-shadow(0 1px 0 var(--media-shadow-current-color));
      flex-shrink: 0;
      display: none;
    }

    @scope (.media-status-indicator) {
      &[data-status="exit-pip"] .media-status-indicator-pip-exit-icon {
        display: block;
      }
    }

    .media-status-indicator-value {
      margin-left: auto;
    }
  }

  @scope (.media-skin[data-theme="minimal"]) {
    @media (pointer: coarse) {
    }

    @media (pointer: fine) {
    }

    @media (pointer: fine) {
    }

    @media (prefers-reduced-transparency: reduce), (prefers-contrast: more) {
    }

    .media-volume-indicator-fill {
      border-radius: inherit;
      grid-template-columns: auto minmax(0, 1fr) auto;
      width: min(80%, 14rem);
      display: grid;
      transform: translateX(0);
    }

    .media-volume-indicator-fill:before {
      height: calc(var(--media-spacing) * 0.75);
      content: "";
      width: 100%;
      box-shadow:
        0 0 #0000,
        0 0 #0000,
        0 0 #0000,
        0 0 #0000,
        0 1px 0 var(--media-shadow-subtle-current-color);
      background-color: currentColor;
      border-radius: 9999px;
      grid-row-start: 1;
      grid-column-start: 2;
    }

    @supports (color: color-mix(in lab, red, red)) {
      .media-volume-indicator-fill:before {
        background-color: color-mix(in oklab, currentcolor 20%, transparent);
      }
    }

    .media-volume-indicator-fill:after {
      height: calc(var(--media-spacing) * 0.75);
      width: var(--media-volume-fill, 0%);
      background-color: var(--media-primary);
      transition-property: width;
      transition-duration: 0.15s;
      transition-duration: var(--media-duration-slow);
      content: "";
      border-radius: 9999px;
      grid-row-start: 1;
      grid-column-start: 2;
      justify-self: flex-start;
      transition-timing-function: linear;
    }

    @media (prefers-reduced-motion: no-preference) {
      @scope (.media-volume-indicator) {
        &:is([data-min], [data-max]):not([data-starting-style], [data-ending-style]) .media-volume-indicator-fill {
          transition: transform 0.3s linear(0, -24 20%, 16 40%, -8 60%, 4 80%, 1);
          transform: translateX(0.25px);
        }
      }
    }

    .media-volume-indicator-high-icon {
      filter: drop-shadow(0 1px 0 var(--media-shadow-current-color));
      flex-shrink: 0;
      grid-row-start: 1;
      grid-column-start: 1;
      display: none;
    }

    @scope (.media-volume-indicator) {
      &[data-level="high"] .media-volume-indicator-high-icon {
        display: block;
      }
    }

    .media-volume-indicator-low-icon {
      filter: drop-shadow(0 1px 0 var(--media-shadow-current-color));
      flex-shrink: 0;
      grid-row-start: 1;
      grid-column-start: 1;
      display: none;
    }

    @scope (.media-volume-indicator) {
      &[data-level="low"] .media-volume-indicator-low-icon {
        display: block;
      }
    }

    .media-volume-indicator-off-icon {
      filter: drop-shadow(0 1px 0 var(--media-shadow-current-color));
      flex-shrink: 0;
      grid-row-start: 1;
      grid-column-start: 1;
      display: none;
    }

    @scope (.media-volume-indicator) {
      &[data-level="off"] .media-volume-indicator-off-icon {
        display: block;
      }
    }

    .media-volume-indicator-value {
      grid-row-start: 1;
      grid-column-start: 3;
    }
  }

  @scope (.media-skin[data-theme="minimal"][data-preset="live-video"]) {
    .video-status-indicators {
      pointer-events: none;
      z-index: 20;
      color: var(--media-controls-foreground);
      grid-template-columns: repeat(3, minmax(0, 1fr));
      place-items: center;
      display: grid;
      position: absolute;
      inset: 0;
    }
  }

  @scope (.media-skin[data-theme="minimal"]) {
    .media-airplay-button:not([data-airplay-state="connected"]) {
      --media-icon-airplay-fill-animation: none;
      --media-icon-airplay-triangle-animation: none;
    }

    .media-airplay-button-enter-icon {
      opacity: 0;
    }

    @scope (.media-airplay-button) {
      &:not([data-airplay-state="connected"]) .media-airplay-button-enter-icon {
        opacity: 1;
        scale: 1;
      }
    }

    .media-airplay-button-exit-icon {
      opacity: 0;
    }

    @scope (.media-airplay-button) {
      &[data-airplay-state="connected"] .media-airplay-button-exit-icon {
        opacity: 1;
        scale: 1;
      }
    }

    .media-button-icon {
      width: var(--media-icon-size, calc(var(--media-spacing) * 4.5));
      height: var(--media-icon-size, calc(var(--media-spacing) * 4.5));
      filter: drop-shadow(0 1px 0 var(--media-shadow-current-color));
      transition-property: opacity, scale;
      transition-duration: 0.15s;
      transition-duration: var(--media-duration);
      text-shadow: inherit;
      grid-row-start: 1;
      grid-column-start: 1;
      transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
    }
  }

  @scope (.media-skin[data-theme="minimal"]) {
    .media-popup {
      color: inherit;
      border-style: solid;
      border-width: 0;
      margin: 0;
      overflow: visible;
    }

    .media-popup[data-ending-style] {
      transform: none;
    }

    .media-popup[data-starting-style] {
      transform: translate(var(--media-popup-translate-x-distance, 0), var(--media-popup-translate-y-distance, 0));
      filter: none;
    }

    .media-popup[data-side="bottom"] {
      transform-origin: top;
      --media-popup-translate-y-distance: calc(var(--media-popup-translate-distance) * -1);
    }

    .media-popup[data-side="left"] {
      transform-origin: 100%;
      --media-popup-translate-x-distance: var(--media-popup-translate-distance);
    }

    .media-popup[data-side="right"] {
      transform-origin: 0;
      --media-popup-translate-x-distance: calc(var(--media-popup-translate-distance) * -1);
    }

    .media-popup[data-side="top"] {
      transform-origin: bottom;
      --media-popup-translate-y-distance: var(--media-popup-translate-distance);
    }

    .media-popup:is([data-starting-style], [data-ending-style]) {
      scale: var(--media-hidden-popup-scale) var(--media-hidden-popup-scale);
      opacity: 0;
      filter: blur(var(--media-hidden-popup-blur));
    }

    .media-popup-safe-area:before {
      pointer-events: auto;
      content: "";
      position: absolute;
    }

    .media-popup-safe-area[data-side="bottom"]:before {
      content: "";
      height: var(--media-popup-side-offset);
      inset-inline: 0;
      bottom: 100%;
    }

    .media-popup-safe-area[data-side="left"]:before {
      content: "";
      width: var(--media-popup-side-offset);
      inset-block: 0;
      left: 100%;
    }

    .media-popup-safe-area[data-side="right"]:before {
      content: "";
      width: var(--media-popup-side-offset);
      inset-block: 0;
      right: 100%;
    }

    .media-popup-safe-area[data-side="top"]:before {
      content: "";
      height: var(--media-popup-side-offset);
      inset-inline: 0;
      top: 100%;
    }

    .media-popup-surface {
      background-color: var(--media-popover);
      color: var(--media-popover-foreground);
      box-shadow:
        0 0 0 1px var(--media-surface-border, var(--media-border)),
        var(--media-shadow-surface);
      backdrop-filter: var(--media-backdrop-filter-surface);
    }

    .media-popup-surface:after {
      z-index: 10;
      pointer-events: none;
      border-radius: inherit;
      box-shadow: var(--media-shadow-surface-inset);
      content: "";
      display: none;
      position: absolute;
      inset: 0;
    }

    .media-popup-transition {
      transition-property: opacity, filter, transform, scale;
      transition-duration: var(--media-duration-fast);
      transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
    }

    .media-popup-transition[data-ending-style] {
      transition-duration: var(--media-duration-instant);
    }

    .media-tooltip {
      border-radius: var(--media-control-radius);
      padding-inline: calc(var(--media-spacing) * 2);
      padding-block: var(--media-spacing);
      font-size: calc(var(--media-spacing) * 3.25);
      white-space: nowrap;
      --media-popup-side-offset: var(--media-tooltip-side-offset);
      box-shadow:
        0 0 #0000,
        0 0 #0000,
        0 0 #0000,
        0 0 #0000,
        var(--media-shadow-tooltip) !important;
    }

    .media-tooltip[data-open] {
      align-items: center;
      gap: var(--media-spacing);
      display: flex;
    }

    .media-tooltip-shortcut {
      border-radius: var(--media-spacing);
      background-color: var(--media-muted);
      text-align: center;
      min-width: 1.5em;
      font-family: inherit;
      font-size: calc(var(--media-spacing) * 2.75);
      margin-inline-end: calc(var(--media-spacing) * -1);
      padding: 0.1em;
      font-weight: 600;
      line-height: 1.25;
    }
  }

  :where(.media-skin[data-theme="minimal"]) .media-popup-surface {
    background-color: var(--media-popover);
    color: var(--media-popover-foreground);
    box-shadow:
      0 0 0 1px var(--media-surface-border, var(--media-border)),
      var(--media-shadow-surface);
    backdrop-filter: var(--media-backdrop-filter-surface);
  }

  :where(.media-skin[data-theme="minimal"]) .media-popup-surface:after {
    z-index: 10;
    pointer-events: none;
    border-radius: inherit;
    box-shadow: var(--media-shadow-surface-inset);
    content: "";
    display: none;
    position: absolute;
    inset: 0;
  }

  @scope (.media-skin[data-theme="minimal"]) {
    .media-cast-button-enter-icon {
      opacity: 0;
    }

    @scope (.media-cast-button) {
      &:not([data-cast-state="connected"]) .media-cast-button-enter-icon {
        opacity: 1;
        scale: 1;
      }
    }

    .media-cast-button-exit-icon {
      opacity: 0;
    }

    @scope (.media-cast-button) {
      &[data-cast-state="connected"] .media-cast-button-exit-icon {
        opacity: 1;
        scale: 1;
      }
    }
  }

  @scope (.media-skin[data-theme="minimal"]) {
    .media-fullscreen-button-enter-icon {
      opacity: 0;
    }

    @scope (.media-fullscreen-button) {
      &:not([data-fullscreen]) .media-fullscreen-button-enter-icon {
        opacity: 1;
        scale: 1;
      }
    }

    .media-fullscreen-button-exit-icon {
      opacity: 0;
    }

    @scope (.media-fullscreen-button) {
      &[data-fullscreen] .media-fullscreen-button-exit-icon {
        opacity: 1;
        scale: 1;
      }
    }
  }

  @scope (.media-skin[data-theme="minimal"]) {
    .media-live-button {
      align-items: center;
      gap: calc(var(--media-spacing) * 1.5);
      width: auto;
      padding-inline: calc(var(--media-spacing) * 3);
      padding-block: calc(var(--media-spacing) * 2);
      font-size: calc(var(--media-spacing) * 2.75);
      letter-spacing: 0.05em;
      text-transform: uppercase;
      font-weight: 600;
      line-height: 1;
      display: inline-flex !important;
    }

    .media-live-button:before {
      width: calc(var(--media-spacing) * 2);
      height: calc(var(--media-spacing) * 2);
      transition-property: background-color;
      transition-duration: 0.15s;
      transition-duration: var(--media-duration);
      content: "";
      background-color: currentColor;
      border-radius: 9999px;
      flex-shrink: 0;
      transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
      display: inline-block;
    }

    @supports (color: color-mix(in lab, red, red)) {
      .media-live-button:before {
        background-color: color-mix(in oklab, currentcolor 40%, transparent);
      }
    }

    .media-live-button[data-live-edge]:before {
      content: "";
      background-color: var(--media-live-color);
    }
  }

  @scope (.media-skin[data-theme="minimal"]) {
    .media-pip-button-enter-icon {
      opacity: 0;
    }

    @scope (.media-pip-button) {
      &:not([data-pip]) .media-pip-button-enter-icon {
        opacity: 1;
        scale: 1;
      }
    }

    .media-pip-button-exit-icon {
      opacity: 0;
    }

    @scope (.media-pip-button) {
      &[data-pip] .media-pip-button-exit-icon {
        opacity: 1;
        scale: 1;
      }
    }
  }

  @scope (.media-skin[data-theme="minimal"]) {
    .media-play-button-pause-icon {
      scale: var(--media-hidden-icon-scale) var(--media-hidden-icon-scale);
      opacity: 0;
    }

    @scope (.media-play-button) {
      &[data-started]:not([data-paused]):not([data-ended]) .media-play-button-pause-icon {
        opacity: 1;
        scale: 1;
      }
    }

    .media-play-button-play-icon {
      scale: var(--media-hidden-icon-scale) var(--media-hidden-icon-scale);
      opacity: 0;
    }

    @scope (.media-play-button) {
      &:not([data-ended]):not([data-started]) .media-play-button-play-icon,
      &:not([data-ended])[data-paused] .media-play-button-play-icon {
        opacity: 1;
        scale: 1;
      }
    }

    .media-play-button-restart-icon {
      scale: var(--media-hidden-icon-scale) var(--media-hidden-icon-scale);
      opacity: 0;
    }

    @scope (.media-play-button) {
      &[data-ended] .media-play-button-restart-icon {
        opacity: 1;
        scale: 1;
      }
    }
  }

  @scope (.media-skin[data-theme="minimal"]) {
    .media-captions-button-off-icon {
      opacity: 0;
    }

    @scope (.media-captions-button) {
      &:not([data-active]) .media-captions-button-off-icon {
        opacity: 1;
        scale: 1;
      }
    }

    .media-captions-button-on-icon {
      opacity: 0;
    }

    @scope (.media-captions-button) {
      &[data-active] .media-captions-button-on-icon {
        opacity: 1;
        scale: 1;
      }
    }
  }

  @scope (.media-skin[data-theme="minimal"]) {
    .media-menu-item-indicator {
      opacity: 0;
      flex-shrink: 0;
      margin-inline-start: auto;
      margin-inline-end: calc(var(--media-spacing) * -1);
    }

    @scope (.media-menu-radio-item) {
      &[aria-checked="true"] .media-menu-item-indicator {
        opacity: 1;
      }
    }

    .media-menu-radio-item {
      cursor: pointer;
      justify-content: space-between;
      align-items: center;
      gap: calc(var(--media-spacing) * 1.5);
      border-radius: var(--media-menu-item-radius);
      padding-inline: calc(var(--media-spacing) * 2);
      padding-block: calc(var(--media-spacing) * 1.5);
      text-align: start;
      white-space: nowrap;
      color: inherit;
      font-variant-numeric: tabular-nums;
      outline-offset: -2px;
      transition-property: background-color, color;
      transition-duration: 0.15s;
      transition-duration: var(--media-duration-fast);
      -webkit-user-select: none;
      user-select: none;
      text-shadow: 0 1px 0 var(--media-shadow-current-color);
      outline: 2px solid #0000;
      transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
      display: flex;
      position: relative;
    }

    .media-menu-radio-item:focus-visible {
      outline-offset: 2px;
      outline-color: var(--media-ring);
    }

    .media-menu-radio-item[aria-disabled="true"] {
      pointer-events: none;
      cursor: not-allowed;
      opacity: 0.5;
    }

    .media-menu-radio-item[data-availability="unavailable"],
    .media-menu-radio-item[data-availability="unsupported"] {
      display: none;
    }

    .media-menu-radio-item:where(:focus-visible, [aria-expanded="true"], [data-highlighted]):where(
        :not([aria-disabled="true"])
      ) {
      background-color: var(--media-accent);
      color: var(--media-accent-foreground);
    }

    @supports (top: anchor(top)) {
      .media-menu-radio-item {
        transition-duration: var(--media-duration-instant);
      }

      .media-menu-radio-item[data-highlighted] {
        anchor-name: --media-menu-item-highlight-anchor;
      }

      .media-menu-radio-item:where(:focus-visible, [aria-expanded="true"], [data-highlighted]):where(
          :not([aria-disabled="true"])
        ) {
        transition-duration: var(--media-duration-slow);
        background-color: #0000;
      }
    }

    .media-menu-radio-item-icon {
      width: var(--media-icon-size, calc(var(--media-spacing) * 4.5));
      height: var(--media-icon-size, calc(var(--media-spacing) * 4.5));
      color: var(--media-muted-foreground);
      filter: drop-shadow(0 1px 0 var(--media-shadow-current-color));
      flex-shrink: 0;
    }

    @scope (.media-menu-radio-item) {
      &:where(:focus-visible, [aria-expanded="true"], [data-highlighted]):where(:not([aria-disabled="true"]))
        .media-menu-radio-item-icon {
        color: inherit;
      }
    }
  }

  @scope (.media-skin[data-theme="minimal"]) {
  }

  @scope (.media-skin[data-theme="minimal"]) {
    .media-menu-content {
      max-height: inherit;
      overscroll-behavior: none;
      transition-property: translate, filter;
      transition-duration: 0.15s;
      transition-duration: var(--media-duration-menu);
      anchor-scope: --media-menu-item-highlight-anchor;
      outline-style: none;
      transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
      position: absolute;
      overflow: auto;
    }

    @media (forced-colors: active) {
      .media-menu-content {
        outline-offset: 2px;
        outline: 2px solid #0000;
      }
    }

    .media-menu-content:not([data-submenu]) {
      inset-inline: var(--media-spacing);
      top: var(--media-spacing);
      gap: calc(var(--media-spacing) * 0.5);
      flex-direction: column;
      display: flex;
    }

    .media-menu-content:not([data-submenu])[data-child-open] {
      filter: blur(var(--media-hidden-blur));
      translate: -100%;
    }

    .media-menu-content:not([data-submenu])[data-child-open]:before {
      content: "";
      display: none;
    }

    .media-menu-content[data-submenu] {
      z-index: 10;
      max-height: inherit;
      padding: var(--media-spacing);
      inset-inline: 0;
      top: 0;
    }

    .media-menu-content:not([data-submenu])[data-child-open]:where(:dir(rtl), [dir="rtl"], [dir="rtl"] *) {
      translate: 100%;
    }

    .media-menu-content:is([data-starting-style], [data-ending-style]):before {
      content: "";
      display: none;
    }

    .media-menu-content[data-submenu]:is([data-starting-style], [data-ending-style]) {
      pointer-events: none;
      filter: blur(var(--media-hidden-blur));
      overflow: hidden;
      translate: 100%;
    }

    .media-menu-content[data-submenu]:is([data-starting-style], [data-ending-style]):where(
        :dir(rtl),
        [dir="rtl"],
        [dir="rtl"] *
      ) {
      translate: -100%;
    }

    @supports (top: anchor(top)) {
      .media-menu-content:before {
        content: "";
        position-anchor: --media-menu-item-highlight-anchor;
        inset: anchor(inside);
        overflow-anchor: none;
        pointer-events: none;
        border-radius: var(--media-menu-item-radius);
        background-color: var(--media-accent);
        transition: inset var(--media-duration-fast) ease-in-out;
        position: absolute;
      }

      .media-menu-content:has([data-highlighted=""]):before {
        content: "";
        transition-duration: 0s;
      }
    }

    .media-menu-content:is([data-starting-style], [data-ending-style]) :before {
      content: "";
      display: none;
    }

    .media-menu-popup {
      height: var(--media-menu-height);
      max-height: min(
        var(--media-menu-available-height, calc(var(--media-spacing) * 56)),
        calc(var(--media-spacing) * 56)
      );
      width: var(--media-menu-width);
      max-width: var(--media-menu-available-width);
      min-width: calc(var(--media-spacing) * 44);
      overscroll-behavior: none;
      border-radius: var(--media-popup-radius);
      padding: var(--media-spacing);
      transition-property: opacity, filter, transform, scale;
      transition-duration: var(--media-duration-fast);
      --media-popup-side-offset: var(--media-popover-side-offset);
      border-style: solid;
      border-width: 0;
      margin: 0;
      transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
      overflow: hidden !important;
    }

    .media-menu-popup:is([data-starting-style], [data-ending-style]) {
      transition-property: opacity, filter, transform, scale;
      transition-duration: var(--media-duration-fast);
      transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
    }

    .media-menu-radio-group {
      max-height: inherit;
      gap: calc(var(--media-spacing) * 0.5);
      anchor-scope: --media-menu-item-highlight-anchor;
      flex-direction: column;
      display: flex;
    }

    .media-menu-radio-group:is([data-starting-style], [data-ending-style]):before {
      content: "";
      display: none;
    }

    @supports (top: anchor(top)) {
      .media-menu-radio-group:before {
        content: "";
        position-anchor: --media-menu-item-highlight-anchor;
        inset: anchor(inside);
        overflow-anchor: none;
        pointer-events: none;
        border-radius: var(--media-menu-item-radius);
        background-color: var(--media-accent);
        transition: inset var(--media-duration-fast) ease-in-out;
        position: absolute;
      }

      .media-menu-radio-group:has([data-highlighted=""]):before {
        content: "";
        transition-duration: 0s;
      }
    }

    .media-menu-radio-group:is([data-starting-style], [data-ending-style]) :before {
      content: "";
      display: none;
    }
  }

  @scope (.media-skin[data-theme="minimal"]) {
    .media-mute-button-high-icon {
      opacity: 0;
    }

    @scope (.media-mute-button) {
      &:not([data-muted]):not([data-volume-level="low"]) .media-mute-button-high-icon {
        opacity: 1;
        scale: 1;
      }
    }

    .media-mute-button-low-icon {
      opacity: 0;
    }

    @scope (.media-mute-button) {
      &:not([data-muted])[data-volume-level="low"] .media-mute-button-low-icon {
        opacity: 1;
        scale: 1;
      }
    }

    .media-mute-button-off-icon {
      opacity: 0;
    }

    @scope (.media-mute-button) {
      &[data-muted] .media-mute-button-off-icon {
        opacity: 1;
        scale: 1;
      }
    }
  }

  @scope (.media-skin[data-theme="minimal"]) {
    .media-slider-buffer {
      pointer-events: none;
      position: absolute;
      inset: 0;
    }

    .media-slider-buffer:before {
      border-radius: var(--media-control-radius);
      content: "";
      background-color: currentColor;
      width: 100%;
      height: 100%;
      position: absolute;
    }

    @supports (color: color-mix(in lab, red, red)) {
      .media-slider-buffer:before {
        background-color: color-mix(in oklab, currentcolor 20%, transparent);
      }
    }

    .media-slider-buffer[data-orientation="horizontal"] {
      left: calc(var(--media-slider-chapter-start, 0%) + var(--media-spacing) * var(--media-chapter-inset-start, 0));
      right: max(
        calc(100% - var(--media-slider-buffer)),
        calc(100% - var(--media-slider-chapter-end, 100%) + var(--media-spacing) * var(--media-chapter-inset-end, 0))
      );
      clip-path: inset(-1px 0);
    }

    .media-slider-buffer[data-orientation="horizontal"]:before {
      content: "";
      min-width: var(--media-spacing);
      left: 0;
    }

    .media-slider-buffer[data-orientation="vertical"] {
      bottom: calc(var(--media-slider-chapter-start, 0%) + var(--media-spacing) * var(--media-chapter-inset-start, 0));
      top: max(
        calc(100% - var(--media-slider-buffer)),
        calc(100% - var(--media-slider-chapter-end, 100%) + var(--media-spacing) * var(--media-chapter-inset-end, 0))
      );
      clip-path: inset(0 -1px);
    }

    .media-slider-buffer[data-orientation="vertical"]:before {
      content: "";
      min-height: var(--media-spacing);
      bottom: 0;
    }

    .media-slider-fill {
      pointer-events: none;
      position: absolute;
      inset: 0;
    }

    .media-slider-fill:before {
      border-radius: var(--media-control-radius);
      content: "";
      background-color: var(--media-primary);
      width: 100%;
      height: 100%;
      position: absolute;
    }

    .media-slider-fill[data-orientation="horizontal"] {
      left: calc(var(--media-slider-chapter-start, 0%) + var(--media-spacing) * var(--media-chapter-inset-start, 0));
      right: max(
        calc(100% - var(--media-slider-fill)),
        calc(100% - var(--media-slider-chapter-end, 100%) + var(--media-spacing) * var(--media-chapter-inset-end, 0))
      );
      clip-path: inset(-1px 0);
    }

    @scope (.media-slider) {
      &[data-dragging] .media-slider-fill[data-orientation="horizontal"] {
        left: calc(var(--media-slider-chapter-start, 0%) + var(--media-spacing) * var(--media-chapter-inset-start, 0));
        right: max(
          calc(100% - var(--media-slider-pointer)),
          calc(100% - var(--media-slider-chapter-end, 100%) + var(--media-spacing) * var(--media-chapter-inset-end, 0))
        );
        clip-path: inset(-1px 0);
      }
    }

    .media-slider-fill[data-orientation="horizontal"]:before {
      content: "";
      min-width: var(--media-spacing);
      left: 0;
    }

    .media-slider-fill[data-orientation="vertical"] {
      bottom: calc(var(--media-slider-chapter-start, 0%) + var(--media-spacing) * var(--media-chapter-inset-start, 0));
      top: max(
        calc(100% - var(--media-slider-fill)),
        calc(100% - var(--media-slider-chapter-end, 100%) + var(--media-spacing) * var(--media-chapter-inset-end, 0))
      );
      clip-path: inset(0 -1px);
    }

    @scope (.media-slider) {
      &[data-dragging] .media-slider-fill[data-orientation="vertical"] {
        bottom: calc(
          var(--media-slider-chapter-start, 0%) + var(--media-spacing) * var(--media-chapter-inset-start, 0)
        );
        top: max(
          calc(100% - var(--media-slider-pointer)),
          calc(100% - var(--media-slider-chapter-end, 100%) + var(--media-spacing) * var(--media-chapter-inset-end, 0))
        );
        clip-path: inset(0 -1px);
      }
    }

    .media-slider-fill[data-orientation="vertical"]:before {
      content: "";
      min-height: var(--media-spacing);
      bottom: 0;
    }

    .media-slider-thumb {
      top: 50%;
      left: var(--media-slider-fill);
      z-index: 10;
      width: calc(var(--media-spacing) * 3);
      height: calc(var(--media-spacing) * 3);
      border-radius: var(--media-control-radius);
      box-shadow:
        0 0 #0000,
        0 0 #0000,
        0 0 #0000,
        0 0 #0000,
        var(--media-shadow-thumb);
      outline-offset: -2px;
      transition-property: opacity, height, width, outline-offset, scale;
      transition-duration: 0.15s;
      transition-duration: var(--media-duration-slider);
      -webkit-user-select: none;
      user-select: none;
      background-color: #fff;
      outline: 2px solid #0000;
      transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
      position: absolute;
      translate: -50% -50%;
    }

    @scope (.media-slider) {
      &[data-dragging] .media-slider-thumb {
        scale: 0.9;
      }
    }

    .media-slider-thumb:focus-visible {
      outline-offset: 2px;
      outline-color: var(--media-ring);
    }

    @scope (.media-slider) {
      &[data-dragging] .media-slider-thumb[data-orientation="horizontal"] {
        left: var(--media-slider-pointer);
      }
    }

    .media-slider-thumb[data-orientation="vertical"] {
      top: calc(100% - var(--media-slider-fill));
      left: 50%;
    }

    @scope (.media-slider) {
      &[data-dragging] .media-slider-thumb[data-orientation="vertical"] {
        top: calc(100% - var(--media-slider-pointer));
      }
    }

    .media-slider-track {
      isolation: isolate;
      -webkit-user-select: none;
      user-select: none;
      border-radius: 9999px;
      width: 100%;
      position: relative;
    }

    .media-slider-track:before {
      pointer-events: none;
      border-radius: var(--media-control-radius);
      content: "";
      background-color: currentColor;
      position: absolute;
      inset: 0;
    }

    @supports (color: color-mix(in lab, red, red)) {
      .media-slider-track:before {
        background-color: color-mix(in oklab, currentcolor 20%, transparent);
      }
    }

    .media-slider-track[data-orientation="horizontal"] {
      height: var(--media-spacing);
    }

    .media-slider-track[data-orientation="vertical"] {
      height: 100%;
      width: var(--media-spacing);
    }
  }

  @scope (.media-skin[data-theme="minimal"]) {
    .media-slider {
      cursor: pointer;
      transition-property: --media-slider-fill, --media-slider-buffer;
      transition-duration: 0.15s;
      transition-duration: var(--media-duration-slider);
      border-radius: 9999px;
      outline-style: none;
      flex: 1;
      justify-content: center;
      align-items: center;
      transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
      display: flex;
      position: relative;
    }

    @media (forced-colors: active) {
      .media-slider {
        outline-offset: 2px;
        outline: 2px solid #0000;
      }
    }

    .media-slider[data-disabled] {
      pointer-events: none;
    }

    .media-slider[data-dragging] {
      transition-duration: 0s;
    }

    .media-slider[data-orientation="horizontal"] {
      height: var(--media-slider-height, calc(var(--media-spacing) * 8));
      min-width: calc(var(--media-spacing) * 20);
    }

    .media-slider[data-orientation="vertical"] {
      height: calc(var(--media-spacing) * 20);
      width: calc(var(--media-spacing) * 8);
      min-width: 0;
    }

    .media-volume-slider-thumb {
      opacity: 1;
      scale: 1;
    }
  }

  @scope (.media-skin[data-theme="minimal"]) {
    .media-volume-popover {
      border-radius: var(--media-control-radius);
      padding-inline: 0;
      padding-block: calc(var(--media-spacing) * 3);
      --media-popup-side-offset: var(--media-popover-side-offset);
    }

    .media-volume-popover[data-side="left"] {
      background-image: linear-gradient(to left, var(--media-controls) 80%, transparent 100%);
      --media-popover-side-offset: 0rem;
      border-style: solid;
      border-width: 0;
      border-radius: 0;
      padding-block: 0;
      padding-inline-start: calc(var(--media-spacing) * 16);
      padding-inline-end: calc(var(--media-spacing) * 2);
      box-shadow: none !important;
      backdrop-filter: none !important;
      background-color: #0000 !important;
    }

    .media-volume-popover[data-side="left"]:after {
      content: "";
      display: none;
    }

    .media-volume-popover[data-side="right"] {
      padding: 0;
      padding-inline: calc(var(--media-spacing) * 3);
      --media-popover-side-offset: 0rem;
      border-radius: 0;
      box-shadow: none !important;
      backdrop-filter: none !important;
      background-color: #0000 !important;
    }

    .media-volume-popover[data-side="right"]:after {
      content: "";
      display: none;
    }
  }

  @scope (.media-skin[data-theme="minimal"][data-preset="live-video"]) {
    .video-controls-backdrop {
      pointer-events: none;
      z-index: 10;
      border-radius: inherit;
      background-image: var(--media-controls-gradient);
      transition-property: opacity;
      transition-duration: 0.15s;
      transition-duration: var(--media-duration-controls);
      transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
      position: absolute;
      inset: 0;
    }

    .video-controls-backdrop:not([data-visible]) {
      opacity: 0;
    }

    .video-controls-content {
      inset-inline: calc(var(--media-spacing) * 0.5);
      bottom: calc(var(--media-spacing) * 0.5);
      z-index: 30;
      align-items: center;
      column-gap: calc(var(--media-spacing) * 2);
      border-radius: var(--media-controls-radius);
      padding: var(--media-spacing);
      color: var(--media-controls-foreground);
      transition-property: filter, opacity, translate;
      transition-duration: 0.15s;
      transition-duration: calc(var(--media-duration-controls) / 2);
      text-shadow: 0 1px 0 var(--media-shadow-current-color);
      background-color: #0000;
      transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
      display: flex;
      position: absolute;
    }

    .video-controls-content:not([data-visible]) {
      pointer-events: none;
      translate: 0 var(--media-hidden-offset);
      opacity: 0;
      transition-duration: var(--media-duration-controls);
    }

    .video-controls-content:where(:dir(rtl), [dir="rtl"], [dir="rtl"] *) {
      flex-direction: row-reverse;
    }

    @media (pointer: fine) {
      .video-controls-content:not([data-visible]) {
        filter: blur(var(--media-hidden-blur));
      }
    }

    @media (prefers-reduced-transparency: reduce), (prefers-contrast: more) {
      .video-controls-content {
        background-color: var(--media-background);
      }
    }

    @container media-root (width >= 42rem) {
      .video-controls-content {
        inset-inline: calc(var(--media-spacing) * 2);
        bottom: calc(var(--media-spacing) * 2);
        --media-popover-side-offset: calc(var(--media-spacing) * 3);
        --media-tooltip-side-offset: var(--media-popover-side-offset);
      }
    }

    .video-controls-spacer {
      flex: 1;
    }
  }

  @scope (.media-skin[data-theme="minimal"][data-preset="live-video"]) {
    .video-controls-end {
      transition: mask-position var(--media-duration-instant) ease-out;
      align-items: center;
      gap: 1px;
      display: flex;
      mask-position: 100% 0;
      mask-size: 400% 100%;
      mask-repeat: no-repeat;
    }

    @scope (.video-controls-content) {
      &:has([data-volume-level][aria-expanded="true"]) .video-controls-end {
        mask-image: linear-gradient(to right, #0000 10%, #000 25% 100%);
        mask-position: 0 0;
      }
    }

    .video-controls-end:where(:dir(rtl), [dir="rtl"], [dir="rtl"] *) {
      flex-direction: row-reverse;
    }

    .video-controls-start {
      align-items: center;
      gap: 1px;
      display: flex;
    }

    .video-controls-start:where(:dir(rtl), [dir="rtl"], [dir="rtl"] *) {
      flex-direction: row-reverse;
    }
  }

  @scope (.media-skin[data-theme="minimal"][data-preset="live-video"]) {
    @media (pointer: fine) {
      .video-skin:not([data-controls-visible]),
      :scope.video-skin:not([data-controls-visible]) {
        cursor: none;
      }
    }
  }
}

@layer utilities;

@property --media-slider-fill {
  syntax: "<percentage>";
  inherits: true;
  initial-value: 0%;
}

@property --media-slider-buffer {
  syntax: "<percentage>";
  inherits: true;
  initial-value: 0%;
}
